import classNames from 'classnames';
import { PropsWithChildren, PropsWithClassName } from 'lib-shared-types-utils';
import { forwardRef, ReactNode } from 'react';

import styles from './dashboardCard.module.scss';

type DashboardCardProps = {
  /** The element to render in the title slot on the left. */
  titleSlot: ReactNode;
  /** The element to render in the actions slot on the right. */
  actionsSlot: ReactNode;
} & PropsWithChildren &
  PropsWithClassName;

export const DashboardCard = forwardRef<HTMLDivElement, DashboardCardProps>(
  function DashboardCard(
    { className, children, titleSlot, actionsSlot },
    ref,
  ): JSX.Element {
    return (
      <div className={classNames(styles.card, className)} ref={ref}>
        <div className={styles.header}>
          {titleSlot}
          {actionsSlot}
        </div>

        <div className={styles.content}>{children}</div>
      </div>
    );
  },
);
